import { render, staticRenderFns } from "./ServiceInformation.vue?vue&type=template&id=3a2d3b0a"
import script from "./ServiceInformation.vue?vue&type=script&lang=js"
export * from "./ServiceInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a2d3b0a')) {
      api.createRecord('3a2d3b0a', component.options)
    } else {
      api.reload('3a2d3b0a', component.options)
    }
    module.hot.accept("./ServiceInformation.vue?vue&type=template&id=3a2d3b0a", function () {
      api.rerender('3a2d3b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/management/contract/components/ServiceInformation.vue"
export default component.exports